import Uri from "jsuri";

const EnvNames = {
	DEV: "DEV",
	STAGE: "STAGE",
	PROD: "PROD",
	QA: "QA",
	UAT: "UAT",
};

const ConnectPortalUrls = {
	[EnvNames.DEV]: "https://connect.dev.redhat.com/",
	[EnvNames.QA]: "https://connect.qa.redhat.com/",
	[EnvNames.STAGE]: "https://connect.stage.redhat.com/",
	[EnvNames.PROD]: "https://connect.redhat.com/",
	[EnvNames.UAT]: "https://connect.uat.redhat.com/",
};

// Add any new services consuming hydrajs to below arrays
const getEnvName = (): string => {
	// Returns PROD | QA | FTE | CI | STAGE
	const prodHostNames = [
		"connect.redhat.com",
		"prod.foo.redhat.com",
		"connect.uat.redhat.com",
		"prod.spaship--partner-connect.partner-connect.prod.apps.int.spoke.prod.us-west-2.aws.paas.redhat.com",
	];
	const qaHostNames = [
		"stage.foo.redhat.com",
		"connect.qa.redhat.com",
		"qa.foo.redhat.com",
		"preprod.spaship--partner-connect.partner-connect.qa.apps.int.spoke.preprod.us-east-1.aws.paas.redhat.com",
	];
	const stageHostNames = [
		"connect.stage.redhat.com",
		"stage-connect.redhat.com",
		"preprod.spaship--partner-connect.partner-connect.stage.apps.int.spoke.preprod.us-east-1.aws.paas.redhat.com",
	];
	const uatHostNames = [
		"prod.spaship--partner-connect.partner-connect.uat.apps.int.spoke.prod.us-west-2.aws.paas.redhat.com",
	];
	if (prodHostNames.indexOf(window.location.hostname) !== -1) {
		return EnvNames.PROD;
	} else if (uatHostNames.indexOf(window.location.hostname) !== -1) {
		return EnvNames.UAT;
	} else if (stageHostNames.indexOf(window.location.hostname) !== -1) {
		return EnvNames.STAGE;
	} else if (qaHostNames.indexOf(window.location.hostname) !== -1) {
		return EnvNames.QA;
	} else {
		return EnvNames.DEV;
	}
};

// for custom api hostname
const getAPIUrl = () => {
	switch (getEnvName()) {
		case EnvNames.DEV:
			return new Uri("https://catalog.qa.redhat.com");
		case EnvNames.QA:
			return new Uri("https://catalog.qa.redhat.com");
		case EnvNames.STAGE:
			return new Uri("https://catalog.stage.redhat.com");
		case EnvNames.UAT:
			return new Uri("https://catalog.uat.redhat.com");
		case EnvNames.PROD:
			return new Uri("https://catalog.redhat.com");
		default:
			return new Uri("https://catalog.qa.redhat.com");
	}
};

const getFileUploadAPIUrl = () => {
	if (EnvNames.STAGE === getEnvName()) {
		return "https://jwt-s3-gw-connect-stage.apps.ext-waf.spoke.preprod.us-east-1.aws.paas.redhat.com/s3api/stage-s3api/";
	} else if (EnvNames.PROD === getEnvName()) {
		return "https://connect.redhat.com/s3api/prod-s3api/";
	} else if (EnvNames.UAT === getEnvName()) {
		return "https://connect.uat.redhat.com/s3api/prod-s3api/";
	} else {
		// for QA and dev
		return "https://jwt-s3-gw-connect-qa.apps.ext-waf.spoke.preprod.us-east-1.aws.paas.redhat.com/s3api/qa-s3api/";
	}
};

const isConnectPortal = () => {
	return (
		[
			ConnectPortalUrls[EnvNames.PROD],
			ConnectPortalUrls[EnvNames.STAGE],
			ConnectPortalUrls[EnvNames.QA],
			ConnectPortalUrls[EnvNames.DEV],
			ConnectPortalUrls[EnvNames.UAT],
		].indexOf(`${window.location.protocol}//${window.location.hostname}/`) !== -1
	);
};

const getAPIPrefix = () => {
	switch (getEnvName()) {
		case EnvNames.DEV:
			return "/api/containers";
		case EnvNames.QA:
			return "/api/containers";
		case EnvNames.STAGE:
			return "/api/containers";
		case EnvNames.UAT:
			return "/api/containers";
		case EnvNames.PROD:
			return "/api/containers";
		default:
			return "/";
	}
};

// Returns Hydra Proxy URL
const getHydraPoxyUrl = (switchQaToStage?: boolean) => {
	if (typeof window !== "undefined" && window) {
		const envQueryParam = new Uri(window.location.search).getQueryParamValue("env");
		switch (envQueryParam ? envQueryParam : getEnvName()) {
			case EnvNames.DEV:
				return new Uri("https://access.qa.redhat.com");
			case EnvNames.QA:
				return new Uri(switchQaToStage ? "https://access.stage.redhat.com" : "https://access.qa.redhat.com");
			case EnvNames.STAGE:
				return new Uri("https://access.stage.redhat.com");
			case EnvNames.UAT:
				return new Uri("https://access.uat.redhat.com");
			case EnvNames.PROD:
				return new Uri("https://access.redhat.com");
			default:
				return new Uri("https://access.qa.redhat.com");
		}
	}
};

// Returns Hydra API URL
const getHydraAPIUrl = () => {
	if (typeof window !== "undefined" && window) {
		const envQueryParam = new Uri(window.location.search).getQueryParamValue("env");
		switch (envQueryParam ? envQueryParam : getEnvName()) {
			case EnvNames.DEV:
				return new Uri("https://connect.qa.redhat.com");
			case EnvNames.QA:
				return new Uri("https://connect.qa.redhat.com");
			case EnvNames.STAGE:
				return new Uri("https://connect.stage.redhat.com");
			case EnvNames.UAT:
				return new Uri("https://connect.uat.redhat.com");
			case EnvNames.PROD:
				return new Uri("https://connect.redhat.com");
			default:
				return new Uri("https://connect.qa.redhat.com");
		}
	}
};

const getPyxisGraphQlAPIUrl = () => {
	if (typeof window !== "undefined" && window) {
		const envQueryParam = new Uri(window.location.search).getQueryParamValue("env");
		switch (envQueryParam ? envQueryParam : getEnvName()) {
			case EnvNames.DEV:
				return new Uri("https://catalog.qa.redhat.com/api/containers/graphql/");
			case EnvNames.QA:
				return new Uri("https://catalog.qa.redhat.com/api/containers/graphql/");
			case EnvNames.STAGE:
				return new Uri("https://catalog.stage.redhat.com/api/containers/graphql/");
			case EnvNames.UAT:
				return new Uri("https://catalog.uat.redhat.com/api/containers/graphql/");
			case EnvNames.PROD:
				return new Uri("https://catalog.redhat.com/api/containers/graphql/");
			default:
				return new Uri("https://catalog.qa.redhat.com/api/containers/graphql/");
		}
	}
};

const getCatalogURL = () => {
	if (typeof window !== "undefined" && window) {
		const envQueryParam = new Uri(window.location.search).getQueryParamValue("env");
		switch (envQueryParam ? envQueryParam : getEnvName()) {
			case EnvNames.DEV:
				return new Uri("https://catalog.qa.redhat.com/");
			case EnvNames.QA:
				return new Uri("https://catalog.qa.redhat.com/");
			case EnvNames.STAGE:
				return new Uri("https://catalog.stage.redhat.com/");
			case EnvNames.UAT:
				return new Uri("https://catalog.uat.redhat.com/");
			case EnvNames.PROD:
				return new Uri("https://catalog.redhat.com/");
			default:
				return new Uri("https://catalog.qa.redhat.com/");
		}
	}
};

const getPfSCsApiUrl = () => {
	if (typeof window !== "undefined" && window) {
		const envQueryParam = new Uri(window.location.search).getQueryParamValue("env");
		switch (envQueryParam ? envQueryParam : getEnvName()) {
			case EnvNames.DEV:
				return new Uri("https://connect.qa.redhat.com/pfs/cs");
			case EnvNames.QA:
				return new Uri("https://connect.qa.redhat.com/pfs/cs");
			case EnvNames.STAGE:
				return new Uri("https://connect.stage.redhat.com/pfs/cs");
			case EnvNames.UAT:
				return new Uri("https://connect.uat.redhat.com/pfs/cs");
			case EnvNames.PROD:
				return new Uri("https://connect.redhat.com/pfs/cs");
			default:
				return new Uri("https://connect.qa.redhat.com/pfs/cs");
		}
	}
};
const getPfSPsApiUrl = () => {
	if (typeof window !== "undefined" && window) {
		const envQueryParam = new Uri(window.location.search).getQueryParamValue("env");
		switch (envQueryParam ? envQueryParam : getEnvName()) {
			case EnvNames.DEV:
				return new Uri("https://connect.qa.redhat.com/pfs/ps");
			case EnvNames.QA:
				return new Uri("https://connect.qa.redhat.com/pfs/ps");
			case EnvNames.STAGE:
				return new Uri("https://connect.stage.redhat.com/pfs/ps");
			case EnvNames.UAT:
				return new Uri("https://connect.uat.redhat.com/pfs/ps");
			case EnvNames.PROD:
				return new Uri("https://connect.redhat.com/pfs/ps");
			default:
				return new Uri("https://connect.qa.redhat.com/pfs/ps");
		}
	}
};

const getPadCaseListUrl = () => {
	if (typeof window !== "undefined" && window) {
		const envQueryParam = new Uri(window.location.search).getQueryParamValue("env");
		switch (envQueryParam ? envQueryParam : getEnvName()) {
			case EnvNames.DEV:
				return new Uri("https://connect.qa.redhat.com/support/partner-acceleration-desk/#/case/list");
			case EnvNames.QA:
				return new Uri("https://connect.qa.redhat.com/support/partner-acceleration-desk/#/case/list");
			case EnvNames.STAGE:
				return new Uri("https://connect.stage.redhat.com/support/partner-acceleration-desk/#/case/list");
			case EnvNames.UAT:
				return new Uri("https://connect.uat.redhat.com/support/partner-acceleration-desk/#/case/list");
			case EnvNames.PROD:
				return new Uri("https://connect.redhat.com/support/partner-acceleration-desk/#/case/list");
			default:
				return new Uri("https://connect.qa.redhat.com/support/partner-acceleration-desk/#/case/list");
		}
	}
};

const getPadUrl = () => {
	if (typeof window !== "undefined" && window) {
		const envQueryParam = new Uri(window.location.search).getQueryParamValue("env");
		switch (envQueryParam ? envQueryParam : getEnvName()) {
			case EnvNames.DEV:
				return new Uri(" https://connect.qa.redhat.com/support/partner-acceleration-desk/#/case/new");
			case EnvNames.QA:
				return new Uri(" https://connect.qa.redhat.com/support/partner-acceleration-desk/#/case/new");
			case EnvNames.STAGE:
				return new Uri(" https://connect.stage.redhat.com/support/partner-acceleration-desk/#/case/new");
			case EnvNames.UAT:
				return new Uri(" https://connect.uat.redhat.com/support/partner-acceleration-desk/#/case/new");
			case EnvNames.PROD:
				return new Uri(" https://connect.redhat.com/support/partner-acceleration-desk/#/case/new");
			default:
				return new Uri(" https://connect.qa.redhat.com/support/partner-acceleration-desk/#/case/new");
		}
	}
};
const getSuperGraphqlAPIs = () => {
	if (typeof window !== "undefined" && window) {
		const envQueryParam = new Uri(window.location.search).getQueryParamValue("env");
		switch (envQueryParam ? envQueryParam : getEnvName()) {
			case EnvNames.DEV:
				return new Uri("https://vpn.graphql.qa.redhat.com/");
			case EnvNames.QA:
				return new Uri("https://vpn.graphql.qa.redhat.com/");
			case EnvNames.STAGE:
				return new Uri("https://graphql.stage.redhat.com/");
			case EnvNames.UAT:
				return new Uri("https://graphql.redhat.com/");
			case EnvNames.PROD:
				return new Uri("https://graphql.redhat.com/");
			default:
				return new Uri("https://vpn.graphql.qa.redhat.com/");
		}
	}
};

export default class Env {
	static apiHostName = getAPIUrl();
	static apiPrefix = getAPIPrefix();
	static apiVersion = "v1";
	static getEnvName = getEnvName;
	static EnvNames = EnvNames;
	static ConnectPortalUrls = ConnectPortalUrls;
	static getFileUploadAPIUrl = getFileUploadAPIUrl;
	static isConnectPortal = isConnectPortal;
	static hydraProxyURL = getHydraPoxyUrl()!;
	static hydraProxyURLPreprodStage = getHydraPoxyUrl(true)!;
	static hydraProxyPrefix = "/hydra/proxy";
	static hydraAPIURL = getHydraAPIUrl()!;
	static hydraAPIPrefix = "/hydra/prm/v1";
	static routePrefix = "/manage";
	static hydraRestPrefix = "/hydra/rest/configuration";
	static companyProfileURL = `${ConnectPortalUrls[getEnvName()]}account/company-profile`;
	static pyxisGraphqlAPIURL = getPyxisGraphQlAPIUrl()!;
	static productDetailsPrefix = "/products";
	static productInformationPath = "product-information";
	static pfsCsApiUrl = getPfSCsApiUrl()!;
	static pfsPsApiUrl = getPfSPsApiUrl()!;
	static catalogUrl = getCatalogURL()!.toString();
	static padCaseListUrl: string = getPadCaseListUrl()!.toString();
	static padUrl: string = getPadUrl()!.toString();
	static projectPrefix = `${Env.ConnectPortalUrls[Env.getEnvName()]}component`;
	static pfsAPIPrefix = "pfs/non-cont-crt/projects";
	static hydraCWEAPIPrefix = "/hydra/cwe/rest";
	static connectAIAPIURL = getHydraAPIUrl()!;
	static connectAIAPIPrefix = "/ai-service/api";
	static superGraphQl = getSuperGraphqlAPIs();
}
